import { IPatientSelectOption } from '@hilbi/web-common/components/e-visits/select/options/types';
import { memberApiV2 } from 'lib/api';
import { all, call, put, select } from 'typed-redux-saga';
import {
  createOrder,
  getInitialPatients,
} from '../../../services/e-calendar/reservation-form/reservation-form-service';
import { ReservationFormValues } from '../../../types/reservation-form';
import TStore from '../../../types/store';
import { actions } from '../../ducks/reservation-form-slice';
import {
  getDisplayedDates,
  getPatientOptionsFromResponse,
  getTagOptionsFromResponse,
  handleApiError,
} from './reservation-form-saga.utils';

export function* reservationCreate() {
  try {
    const providerId: string = yield select((state: TStore) => state.users.business[0].id);
    const { tagOptionsRes, patientOptionsResponse } = yield* all({
      tagOptionsRes: call(memberApiV2.getTags),
      patientOptionsResponse: call(getInitialPatients, providerId),
    });
    const event = yield* select((state: TStore) => state.reservationForm.event);
    const { displayedDateTime, displayedDate } = getDisplayedDates(event);

    yield* put(
      actions.updateReservationForm({
        patientOptions: getPatientOptionsFromResponse(patientOptionsResponse),
        tagOptions: getTagOptionsFromResponse(tagOptionsRes),
        displayedDateTime,
        displayedDate,
        timeRangePickerHidden: false,
      }),
    );

    yield* put(
      actions.setInitialFormValues({
        timeRangePickerValue: {
          fromTime: event.start,
          toTime: event.end,
        },
      }),
    );

    yield* put(actions.setFormState('idle'));
  } catch (error) {
    yield* call(handleApiError, { error });
  }
}

export function* submitReservationCreateForm({ payload }: { payload: ReservationFormValues }) {
  try {
    const { event } = yield* select((state: TStore) => ({
      event: state.reservationForm.event,
    }));
    const providerId = yield* select((store: TStore) => store.users.business[0].id);

    // @ts-expect-error haha
    const { id: workspaceId } = yield* select((state: TStore) => state.eVisits.selectedInstitution);

    yield* put(actions.setFormState('submitting'));
    yield* call(createOrder, providerId, {
      description: payload.description,
      title: payload.title,
      clientId: (payload.selectedPatient as IPatientSelectOption)?.value,
      workspaceId: workspaceId,
      to: payload.timeRangePickerValue.toTime,
      from: payload.timeRangePickerValue.fromTime,
      tagId: payload.selectedTag?.value || undefined,
    });
    yield* put(actions.setFormState('submit_success'));
  } catch (error) {
    yield* call(handleApiError, { error });
  }
}
